import React from 'react';
import './Expertise.css';

const expertiseAreas = [
  {
    id: 'llm',
    title: 'Decision-Focused Analytics',
    subtitle: 'I turn patterns into action',
    icon: 'BI',
    color: 'var(--accent-purple)',
    proofLabel: 'Seen in',
    proof: ['Earthy Origins ops dashboards', 'GDP vs cancer study', 'Inventory planning reviews'],
    items: [
      'Frame the business question before touching charts.',
      'Use correlation and regression carefully to explain what data does and does not prove.',
      'Build dashboard narratives that guide next decisions, not just metric displays.',
      'Turn findings into action points for operations, marketing, and planning.',
      'Keep communication clear for non-technical stakeholders.',
    ],
  },
  {
    id: 'unet',
    title: 'Applied LLM and NLP',
    subtitle: 'Build fast, evaluate honestly',
    icon: 'ML',
    color: 'var(--accent-teal)',
    proofLabel: 'Built with',
    proof: ['PDF NER with UiPath + AI Center', 'Aura chatbot on Colab', 'LangGraph prompt flows'],
    items: [
      'Design NER and prompt pipelines around real-world input noise.',
      'Fine-tune open-source LLMs with LoRA and PEFT when lightweight iteration matters.',
      'Expose models through practical APIs for text and audio testing.',
      'Evaluate response quality, latency, and failure cases before scaling.',
      'Prioritize reliability first, then sophistication.',
    ],
  },
  {
    id: 'pipeline',
    title: 'Automation and Infrastructure',
    subtitle: 'Workflow design plus runtime ownership',
    icon: 'AUTO',
    color: 'var(--accent-cyan)',
    proofLabel: 'Delivery footprint',
    proof: ['UiPath workflow automation', 'Linux + GCP VM development', 'Ngrok-enabled service demos'],
    items: [
      'Automation: remove repetitive processing work through UiPath and data pipelines.',
      'Automation: transform semi-structured outputs into clean, reusable tables.',
      'Infrastructure: develop and test services in Linux and GCP VM environments.',
      'Infrastructure: monitor runtime behavior and keep handoffs maintainable for teams.',
      'Treat delivery reliability as part of the solution, not a final step.',
    ],
  },
];

const Expertise = () => {
  return (
    <section id="expertise" className="expertise section">
      <div className="container">
        <h2 className="section-title">Areas of Expertise</h2>
        <p className="section-subtitle">
          What I repeatedly deliver across projects, not a static keyword list.
        </p>

        <div className="expertise-grid">
          {expertiseAreas.map((area) => (
            <div key={area.id} className="expertise-card" style={{ '--card-color': area.color }}>
              <div className="card-proof-wrap">
                <p className="proof-label">{area.proofLabel}</p>
                <div className="proof-list">
                  {area.proof.map((proofLine) => (
                    <span key={proofLine} className="proof-chip">{proofLine}</span>
                  ))}
                </div>
              </div>

              <div className="card-body">
                <span className="card-icon">{area.icon}</span>
                <h3 className="card-title">{area.title}</h3>
                <p className="card-subtitle">{area.subtitle}</p>

                <ul className="card-items">
                  {area.items.map((item, i) => (
                    <li key={i}>
                      <span className="item-dot" />
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Expertise;
